import React from 'react';
import { useDispatch } from 'react-redux';

import useDebounce from '../../hooks/useDebounce';
import { addContent, addSavedBox } from '../../modules/editor';

type Props = {
	canDrop: boolean
	seq: number
};

function ContentListDropzone({ canDrop, seq }: Props) {
	const dispatch = useDispatch();

	const [dbActiveTop, activeTop, setActiveTop] = useDebounce<boolean>(
		false,
		30
	);
	const [dbActiveBottom, activeBottom, setActiveBottom] = useDebounce<boolean>(
		false,
		30
	);

	const onDrop = (e: any, position:string) => {
		e.preventDefault();
		const data = e.dataTransfer.getData("text/plain");
		if (data.length === 0) {
			return;
		}
		
		const targetSeq = position === 'bottom' ? seq + 1 : seq;
		
		// 저장된 상자인지 확인
		if (data.startsWith('saved_box:')) {
			const boxId = data.replace('saved_box:', '');
			dispatch(addSavedBox({ seq: targetSeq, boxId }));
		} else {
			// 일반 컴포넌트
			dispatch(addContent({ seq: targetSeq, componentId: data}));
		}
		
		setActiveTop(false);
		setActiveBottom(false);
	}

	const onDragOver = (e: any) => {		
		e.preventDefault();
		e.dataTransfer.dropEffect = "move";
	}

	return (
		<>
		{
			canDrop && (
				<div className='add-content-drop' >
					{
						seq === 0 && (
							<div
								className={dbActiveTop ? 'dropzone top active' : 'dropzone top'}
								onDrop={(e) => {onDrop(e, 'top')}}
								onDragOver={(e:any) => {onDragOver(e); setActiveTop(true)}}
								onDragLeave={(e:any) => {setActiveTop(false)}}
								onDragEnd={(e:any) => {setActiveTop(false)}}
							>
								<div className="drop-line">					
									여기에 상자를 추가합니다.			
								</div>
							</div>
						)
					}
					<div
						className={dbActiveBottom ? 'dropzone bottom active' : 'dropzone bottom'}
						onDrop={(e) => {onDrop(e, 'bottom')}}
						onDragOver={(e:any) => {onDragOver(e); setActiveBottom(true)}}
						onDragLeave={(e:any) => {setActiveBottom(false)}}
						onDragEnd={(e:any) => {setActiveBottom(false)}}
					>
						<div className="drop-line">		
							여기에 상자를 추가합니다.			
						</div>
					</div>
				</div>
			)
		}
		</>
	);
}

export default ContentListDropzone;